import Vue from 'vue';
import utils from '../libs/utils';
import axios from './axios';

const vm = new Vue();
const baseUrl = 'v1/erp-business-web';
export default {
  verifyFingerprint(params) {
    return axios.post(`${baseUrl}/drugAd/verifyFingerprint`, utils.exchangeParams(params));
  },
  getEditLog(params) {
    return axios.get(`${baseUrl}/editLog/list?${utils.exchangeParams(params)}`);
  },
  getLastPrescription(params) {
    return axios.get(`${baseUrl}/saleOrder/getLastPrescription?${utils.exchangeParams(params)}`);
  },
  listGoods(params) {
    return axios.get(`${baseUrl}/saleOrder/listGoods?${utils.exchangeParams(params)}`);
  },
  listStoreGoods(params) {
    return axios.get(`${baseUrl}/saleOrder/promote/listGoods?${utils.exchangeParams(params)}`);
  },
  createOrder(token, params) {
    return axios.post(`${baseUrl}/saleOrder/create?token=${token}`, utils.exchangeParams(params));
  },
  updateColdChainOrder(params) {
    return axios.post(`${baseUrl}/saleOrder/updateColdChainOrder`, utils.exchangeParams(params));
  },

  payOrder(params) {
    return axios.post(`${baseUrl}/saleOrder/proceedsDispatchingOrder`, utils.exchangeParams(params));
  },
  updateOrder(token, params) {
    return axios.post(`${baseUrl}/saleOrder/updateOrder?token=${token}`, utils.exchangeParams(params));
  },
  cancelOrder(params) {
    return axios.post(`${baseUrl}/saleOrder/cancelOrder`, utils.exchangeParams(params));
  },
  confirmReceipt(params) {
    return axios.post(`${baseUrl}/saleOrder/confirmReceipt`, params);
  },
  checkReceipt(params) {
    return axios.post(`${baseUrl}/saleOrder/checkReceipt`, params);
  },
  getDiseaseInfo() {
    return axios.get(`${baseUrl}/saleOrder/getDiseaseList`);
  },

  getRecipeInfo(params) {
    return axios.get(`${baseUrl}/saleOrder/getPrescriptionById?${utils.exchangeParams(params)}`);
  },

  updatePrescription(params) {
    return axios.post(`${baseUrl}/saleOrder/updatePrescription`, utils.exchangeParams(params));
  },
  editPrescription(params) {
    return axios.post(`${baseUrl}/saleOrder/editPrescription`, utils.exchangeParams(params));
  },

  listOrder(params) {
    return axios.get(`${baseUrl}/saleOrder/listOrder?${utils.exchangeParams(params)}`);
  },

  listOrderDetail(params) {
    return axios.get(`${baseUrl}/saleOrder/listDetail?${utils.exchangeParams(params)}`);
  },

  getOrderAllById(params) {
    return axios.get(`${baseUrl}/saleOrder/getOrderAllById?${utils.exchangeParams(params)}`);
  },

  printOrderList(params) {
    return axios.post(`${baseUrl}/saleOrder/printOrderList`, params, { headers: { 'Content-Type': 'application/json' } });
  },

  printPrescriptionPics(params) {
    return axios.post(`${baseUrl}/saleOrder/printPrescriptionPics`, params, { headers: { 'Content-Type': 'application/json' } });
  },

  listOrderPrescription(params) {
    return axios.get(`${baseUrl}/saleOrder/listOrderPrescription?${utils.exchangeParams(params)}`);
  },

  listPrice(params) {
    return axios.get(`${baseUrl}/salePrice/listPrice?${utils.exchangeParams(params)}`);
  },

  listPriceRecord(params) {
    return axios.get(`${baseUrl}/salePrice/listPriceRecord?${utils.exchangeParams(params)}`);
  },
  getPrintPrice(params) {
    return axios.get(`${baseUrl}/salePrice/print?${utils.exchangeParams(params)}`);
  },
  priceFlowInfo(params) {
    return axios.get(`${baseUrl}/salePrice/check?${utils.exchangeParams(params)}`);
  },

  listPriceOne(params) {
    return axios.get(`${baseUrl}/salePrice/getById?${utils.exchangeParams(params)}`);
  },
  downloadListPrice(params) {
    return axios.get(`${baseUrl}/salePrice/listPrice/download?${utils.exchangeParams(params)}`);
  },

  createPrice(params) {
    return axios.post(`${baseUrl}/salePrice/createPrice`, params, {headers: {'Content-Type': 'application/json'}});
  },

  listReport(params) {
    return axios.get(`${baseUrl}/saleReport/listReport?${utils.exchangeParams(params)}`);
  },

  listDetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/listDetailReport?${utils.exchangeParams(params)}`);
  },
  getDetailSummaryNoCancelStatus(params) {
    return axios.get(`${baseUrl}/saleReport/getDetailSummaryNoCancelStatus?${utils.exchangeParams(params)}`);
  },
  getDetailSummary(params) {
    return axios.get(`${baseUrl}/saleReport/getDetailSummary?${utils.exchangeParams(params)}`);
  },
  getDecocEquipSummary(params) {
    return axios.get(`${baseUrl}/saleReport/getDecocEquipSummary?${utils.exchangeParams(params)}`);
  },
  listRxReport(params) {
    return axios.get(`${baseUrl}/saleReport/listRxReport?${utils.exchangeParams(params)}`);
  },
  equipmentDetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadEquipmentDetailReport?${utils.exchangeParams(params)}`, {
	    // responseType: 'blob',
    });
  },
  slicesDetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/listDecoctionDetailReport?${utils.exchangeParams(params)}`);
  },
  slicesDetailExport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadDecoctionDetailReport?${utils.exchangeParams(params)}`, {
	    // responseType: 'blob',
    });
  },

  listEphedrineReport(params) {
    return axios.get(`${baseUrl}/saleReport/listEphedrineReport?${utils.exchangeParams(params)}`);
  },

  downloadReport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadReport?${utils.exchangeParams(params)}`);
  },

  downloadReportDetail(params) {
    return axios.get(`${baseUrl}/saleReport/downloadReportDetail?${utils.exchangeParams(params)}`, {
      // responseType: 'blob',
    });
  },

  downloadRxReport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadRxReport?${utils.exchangeParams(params)}`, {
      // responseType: 'blob',
    });
  },

  downloadEphedrineReport(params) {
    return axios.get(`${baseUrl}/saleReport/downloadEphedrineReport?${utils.exchangeParams(params)}`, {
      // responseType: 'blob',
    });
  },
  downloadlistOrderPrescription(params) {
    return axios.get(`${baseUrl}/saleOrder/listOrderPrescription/download?${utils.exchangeParams(params)}`);
  },

  prescriptionEdit(params) {
    return axios.post(`${baseUrl}/electronic/prescription/edit`, utils.exchangeParams(params));
  },
  getPrescriptionList(params) {
    return axios.get(`${baseUrl}/electronic/prescription/list?${utils.exchangeParams(params)}`);
  },
  getPrescriptionListDownload(params) {
    return axios.get(`${baseUrl}/electronic/prescription/list/download?${utils.exchangeParams(params)}`);
  },

  getPrescriptiondDetail(params) {
    return axios.get(`${baseUrl}/electronic/prescription/detail?${utils.exchangeParams(params)}`);
  },
  getPrescriptionDetailAid(params) {
    return axios.get(`${baseUrl}/electronic/prescription/detailAid?${utils.exchangeParams(params)}`);
  },
  getSourceList(params) {
    return axios.get(`${baseUrl}/electronic/prescription/source/list?${utils.exchangeParams(params)}`);
  },
  getGoodsListById(params) {
    return axios.get(`${baseUrl}/saleOrder/listGoodsById?${utils.exchangeParams(params)}`);
  },
  getListGoodsByIdEp(params) {
    return axios.get(`${baseUrl}/saleOrder/listGoodsByIdEp?${utils.exchangeParams(params)}`);
  },
  getListRetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/listRetailReport?${utils.exchangeParams(params)}`);
  },
  createFromPrescription(token, params) {
    return axios.post(`${baseUrl}/saleOrder/createFromPrescription?token=${token}`, utils.exchangeParams(params));
  },

  getRxPrintData(params) {
    return axios.get(`${baseUrl}/saleReport/printRxReport?${utils.exchangeParams(params)}`);
  },
  getListSourceType(params) {
    return axios.get(`${baseUrl}/saleOrder/listSourceType?${utils.exchangeParams(params)}`);
  },
  downloadListRetailReport(params) {
    return axios.get(`${baseUrl}/saleReport/listRetailReport/download?${utils.exchangeParams(params)}`);
  },
  // 来源类型
  getSaleOrderListSourceType(params) {
    return axios.get(`${baseUrl}/saleOrder/listSourceType?${utils.exchangeParams(params)}`);
  },
  // 来源姓名
  getSaleOrderListEPCreator(params) {
    return axios.get(`${baseUrl}/saleOrder/listEPCreator?${utils.exchangeParams(params)}`);
  },
  getPatientSaleInfo(params) { // 患者用药信息
    return axios.get(`${baseUrl}/saleOrder/patientSaleInfo?${utils.exchangeParams(params)}`);
  },
  getListFinanceDepositExistReceivables(params) { // 收银台处 预收单查询
    return axios.get(`${baseUrl}/financeDeposit/listFinanceDepositExistReceivables?${utils.exchangeParams(params)}`);
  },
  getExistReceivablesList() {
    return new Promise((resolve) => {
      this.getListFinanceDepositExistReceivables({ existReceivables: 1 }).then((res) => {
        if (res.data.status === 200) {
          resolve(res.data.data.list);
        } else {
          vm.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    });
  },
  prescriptionUnPassReview(params) {
    return axios.post(`${baseUrl}/electronic/prescription/prescriptionUnPassReview`, params);
  },
  prescriptionPassReview(params) {
    return axios.post(`${baseUrl}/electronic/prescription/prescriptionPassReview`, params);
  },
  prescriptionReplacePic(params) {
    return axios.post(`${baseUrl}/electronic/prescription/replacePic`, params);
  },
  savePharmaceuticalCareInfo(params) {  // 提交药事服务
    return axios.post(`/v1/erp-business-web/pharmaceuticalCare/savePharmaceuticalCareInfo`, params);
  },
  pharmaceuticalList(params) {  // 药师服务列表
    return axios.get(`/v1/erp-business-web/pharmaceuticalCare/list?${utils.exchangeParams(params)}`);
  },
  getPharmaceuticalCareInfoDetail(params) {  // 药师服务详情页
    return axios.get(`/v1/erp-business-web/pharmaceuticalCare/pharmaceuticalCareInfoDetail?${utils.exchangeParams(params)}`);
  },
  getPharmaceuticalDetail(params) {  // 加载执行随访填写信息页展示信息
    return axios.get(`/v1/erp-business-web/pharmaceuticalCare/detail?${utils.exchangeParams(params)}`);
  },
  getHistoyPharmaceuticalDetail(params) {  // 历史随访展示信息
    return axios.get(`/v1/erp-business-web/pharmaceuticalCare/InterviewDetail?${utils.exchangeParams(params)}`);
  },
  saveInterviewInfo(params) {  // 保存执行随访填写信息
    return axios.post(`/v1/erp-business-web/pharmaceuticalCare/saveInterviewInfo`, params);
  },
  prescriptionCancel(params) {
    return axios.post(`${baseUrl}/electronic/prescription/cancel`, params);
  },
  promoteMatch(params) { // 诺华瑞弗兰促销活动获取折扣信息
    return axios.post(`${baseUrl}/promote/sale/match`, params);
  },
  getCitys() { // 获取省市列表
    return axios.get(`/v1/erp-business-web/salePrice/getCityRegion`, {});
  },
  getRefundListReport(params) {
    return axios.get(`/v1/erp-business-web/onlineOrderRefund/listReport?${utils.exchangeParams(params)}`);
  },
  getRefundlistDownload(params) {
    return axios.get(`/v1/erp-business-web/onlineOrderRefund/listDownload?${utils.exchangeParams(params)}`);
  },
  getRefundReasonType() {
    return axios.get('/v1/erp-business-web/onlineOrderRefund/listRefundReasonType');
  },
  updateElecPrescription(params) { // 更新关联电子处方状态
    return axios.post(`${baseUrl}/electronic/prescription/updateElectronicInfoByCode`, params);
  },
  getPrintData(params) { // 菜鸟打印获取打印信息
    return axios.get(`${baseUrl}/electronic/prescription/getPrintData?${utils.exchangeParams(params)}`);
  },
  getCreatUser() {
    return axios.get(`${baseUrl}/pharmaceuticalCare/taskCreateUserList`);
  },
  getTaskModifiedUserList() {
    return axios.get(`${baseUrl}/pharmaceuticalCare/taskModifiedUserList`);
  },
  getReceivableList(params) {
    return axios.post(`${baseUrl}/receivableLimit/list`, utils.exchangeParams(params));
  },
  getAmountsInfo(params) {
    return axios.post(`${baseUrl}/receivableLimit/getAmountsInfo`, utils.exchangeParams(params));
  },
  receiveableLimieSubmit(params) {
    return axios.post(`${baseUrl}/receivableLimit/submit`, utils.exchangeParams(params));
  },
  getApprovalInfo(params) {
    return axios.get(`${baseUrl}/receivableLimit/getApprovalInfo?${utils.exchangeParams(params)}`);
  },
  toDownLoadReceiveLimitDoc(params) {
    return axios.get(`${baseUrl}/receivableLimit/list/download?${utils.exchangeParams(params)}`);
  },
  toCancelSfMedicineOrder(params) { // 取消顺丰运单
    return axios.post(`${baseUrl}/shunfeng/cancelSFmedicineOrder`, utils.exchangeParams(params));
  },
  getListLogistics(params) { // 顺丰物流查询
    return axios.get(`${baseUrl}/shunfeng/listLogistics?${utils.exchangeParams(params)}`);
  },
  getSFlistTemperatures(params) { // 冷链温度查询
    return axios.get(`${baseUrl}/shunfeng/listTemperatures?${utils.exchangeParams(params)}`);
  },
  getExpressFee(params) { // 获取顺丰运费
    return axios.post(`${baseUrl}/shunfeng/getExpressFee`, params);
  },
  getExpressInfo(params) { // 选配送订单时获取相关发货，配送方式信息等
    return axios.post(`${baseUrl}/shunfeng/listeliveryMethod`, params);
  },
  checkOrder(params) {
    return axios.post(`${baseUrl}/mxOrder/auditBack`, params);
  },
  exportDrugFlow(params) {
    return axios.get(`${baseUrl}/saleReport/downloadRxReportAndRefund?${utils.exchangeParams(params)}`);
  },
  getCompanyList(params) {
    return axios.get(`${baseUrl}/salePrice/getSupperInfoByGoods?${utils.exchangeParams(params)}`);
  },
  updateOrderInfo(params) {
    return axios.post(`${baseUrl}/saleOrder/updateOrderExternal`, params);
  },
  getRetailDetailSummary(params) {
    return axios.get(`${baseUrl}/saleReport/listRetailReportSummary?${utils.exchangeParams(params)}`);
  },
};
